<template>
    <div>
        <Head>
            <title>{{ pageName }}</title>
            <meta name="description" :content="metaDescription" />
            <meta name="keywords" :content="metaKeywords" />
        </Head>
        <Cms
            content-prop="cmsContent"
            model="content-section"
            :search-params="searchParams"
            driver="builder"
            v-model="builderData" 
            :readable-fields="['pageName', 'metaDescription', 'metaKeywords']"
            :components="getBuilderComponents()"
            is-section
        />
        <YotpoWidget
            :instance_id="yotpoInstanceId"
            :widgetProps="{}"
            :html="props.yotpo_testimonials"
        />
    </div>
</template>
<script setup lang="ts">
    import Cms from "@/components/Cms.vue";
    import YotpoWidget from "@/components/YotpoWidget.vue";
    import { onMounted, watch, ref, computed, nextTick } from "vue";
    import { getBuilderComponents } from "@root/builder-components.ts";
    import { useRothcoBreakpoints } from "@/helpers/composables/useBreakpoints";
    import { useMutationObserver } from "@vueuse/core";
    import { Head } from '@inertiajs/vue3';

     const yotpoInstanceId = import.meta.env.VITE_YOTPO_SEOPAGE_INSTANCE_ID;

    const props = defineProps({
        pageName: {
            type: String,
            default: "Testimonials"
        },
        cmsContent: {
            type: Object,
            default: () => ({
                data: {
                    pageName: null,
                    metaDescription: "",
                    metaKeywords: ""
                }
            }),
        },
        yotpo_testimonials: {
            type: String
        }
    });

    let searchParams = computed(()=>{
        return {
            'data.pageUrl.$eq': 'testimonials'
        }
    });

    let builderData = ref({
        pageName: ""
    });

    let pageName = computed(()=>{
        return props.cmsContent?.data?.pageName ?? builderData.value.pageName ?? props.pageName;
    })

    let metaDescription = computed(()=>{
        return props.cmsContent?.data?.metaDescription ?? builderData.value.metaDescription;
    })
    let metaKeywords = computed(()=>{
        return props.cmsContent?.data?.metaKeywords ?? builderData.value.metaKeywords;
    })
</script> 